export default {
    workLoadBalance:     { method: 'get',    url: 'control_panel/work_load_balance'},
    
}